/* Sisters Moto: "Compatible bikes" finder on product pages (snippets/sm-product-details.liquid).
   The list of rows (make, model, years) is either printed in the page from the product's
   custom.fitment_motofit field (readable by search engines), or built by the fitment script in
   sections/main-product.liquid from MotoFit's data when the field is empty. This file only adds the
   search box, make chips, "Show all" and the "Your bike" mark on top of those rows.
   Rows: .sm-cf__row[data-make][data-model][data-years] inside [data-cf-rows]. */
(function () {
  'use strict';
  var LIMIT = 12;

  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function esc(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  // "2011–2012, 2015" -> [2011, 2012, 2015]
  function years(text) {
    var out = [];
    String(text || '').split(',').forEach(function (part) {
      var m = part.match(/(\d{4})\s*(?:[-–]\s*(\d{4}))?/);
      if (!m) return;
      var a = +m[1], b = m[2] ? +m[2] : a;
      for (var y = a; y <= b && y - a < 80; y++) out.push(y);
    });
    return out;
  }
  function mark(text, words) {
    var out = esc(text);
    words.forEach(function (w) {
      if (w.length < 2) return;
      out = out.replace(new RegExp('(' + escRe(esc(w)) + ')', 'ig'), '<mark>$1</mark>');
    });
    return out;
  }

  function init(slot) {
    if (!slot || slot.__smCf) return;
    var rowsEl = slot.querySelector('[data-cf-rows]');
    var qEl = slot.querySelector('[data-cf-q]');
    if (!rowsEl || !qEl) return;
    slot.__smCf = true;
    var countEl = slot.querySelector('[data-cf-count]');
    var moreBtn = slot.querySelector('[data-cf-more]');
    var baseCount = countEl ? countEl.textContent : '';
    var make = '';
    var expanded = false;
    var myKey = '';

    var items = Array.prototype.slice.call(rowsEl.querySelectorAll('.sm-cf__row')).map(function (row) {
      var mk = row.getAttribute('data-make') || '';
      var md = row.getAttribute('data-model') || '';
      var yt = row.getAttribute('data-years') || '';
      var hay = norm(mk + ' ' + md);
      return {
        row: row, make: mk, model: md, yearsText: yt, years: years(yt),
        hay: hay, hayTight: hay.replace(/ /g, ''),
        makeEl: row.querySelector('.sm-cf__make'), modelEl: row.querySelector('.sm-cf__model'), yearsEl: row.querySelector('.sm-cf__years')
      };
    });

    function render() {
      var raw = (qEl.value || '').trim();
      var q = norm(raw);
      var ym = q.match(/\b(19[5-9]\d|20[0-4]\d)\b/);
      var year = ym ? ym[0] : '';
      var words = (year ? q.replace(year, ' ') : q).split(' ').filter(Boolean);
      var showAll = expanded || raw || make;
      var matches = 0, lastMake = '';
      items.forEach(function (it) {
        var ok = (!make || it.make === make) &&
          (!year || it.years.indexOf(Number(year)) > -1) &&
          words.every(function (w) { return it.hay.indexOf(w) > -1 || it.hayTight.indexOf(w) > -1; });
        if (ok) matches++;
        var mine = myKey && norm(it.make + ' ' + it.model) === myKey;
        // the shopper's own bike always shows, even past the first rows
        var show = ok && (showAll || matches <= LIMIT || mine);
        it.row.hidden = !show;
        if (!show) return;
        var first = it.make !== lastMake;
        lastMake = it.make;
        it.row.classList.toggle('is-first', first);
        it.row.classList.toggle('is-mine', !!mine);
        if (it.makeEl) it.makeEl.innerHTML = mark(it.make, words);
        if (it.modelEl) it.modelEl.innerHTML = mark(it.model, words) + (mine ? ' <em class="sm-cf__mine">&#10003; Your bike</em>' : '');
        if (it.yearsEl) it.yearsEl.innerHTML = (year ? '<mark>' + esc(year) + '</mark> &middot; ' : '') + esc(it.yearsText);
      });
      var empty = slot.querySelector('[data-cf-empty]');
      if (empty) {
        empty.hidden = matches > 0;
        var q2 = empty.querySelector('[data-cf-empty-q]');
        if (q2) q2.textContent = raw;
      }
      if (countEl) {
        countEl.textContent = (raw || make)
          ? matches + (matches === 1 ? ' match' : ' matches') + (year ? ' for ' + year : '')
          : baseCount;
      }
      if (moreBtn) {
        var more = !showAll && matches > LIMIT;
        moreBtn.hidden = !more;
        if (more) moreBtn.textContent = 'Show all ' + matches + ' models';
      }
    }

    qEl.addEventListener('input', render);
    slot.addEventListener('click', function (e) {
      var chip = e.target.closest('.sm-cf__chip');
      if (chip) {
        make = chip.getAttribute('data-make') || '';
        slot.querySelectorAll('.sm-cf__chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        render();
      }
      if (e.target.closest('[data-cf-more]')) { expanded = true; render(); }
    });
    // "Your bike": the one-line fitment status (snippets/sm-pdp-fit-line.liquid) says which bike fits
    function onStatus(d) {
      d = d || {};
      var label = d.state === 'fits' ? norm(d.vehicle) : '';
      myKey = '';
      if (label) {
        // "2020 KTM 350 SX-F": the exact make + model after the year, else the longest one inside the
        // label (so "350 SX-F" wins over "350 SX")
        var bare = label.replace(/^(19|20)\d\d /, '');
        items.forEach(function (it) {
          var k = norm(it.make + ' ' + it.model);
          if (k === bare) myKey = k;
        });
        if (!myKey) {
          items.forEach(function (it) {
            var k = norm(it.make + ' ' + it.model);
            if ((' ' + label + ' ').indexOf(' ' + k + ' ') > -1 && k.length > myKey.length) myKey = k;
          });
        }
      }
      render();
    }
    document.addEventListener('smoto:fitment:status', function (e) { onStatus(e.detail); });
    if (window.smFitmentLast) onStatus(window.smFitmentLast); else render();
    slot.hidden = false;
    var nav = document.querySelector('[data-sm-compat-nav]');
    if (nav) nav.hidden = false;
    document.documentElement.classList.add('sm-compat-ready');
  }

  window.SmCompatFinder = { init: init };
  function boot() { document.querySelectorAll('[data-sm-compat][data-cf-server]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
